import { render } from "./APIKEY.vue?vue&type=template&id=452bd58c&scoped=true"
import script from "./APIKEY.vue?vue&type=script&lang=js"
export * from "./APIKEY.vue?vue&type=script&lang=js"

import "./APIKEY.vue?vue&type=style&index=0&id=452bd58c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-452bd58c"

export default script